import { TemplateState } from "../types";

export const mergeThemeWithTemplate = (
  existingTemplate: TemplateState,
  themeState: TemplateState,
  slideHasImageElement = false
): TemplateState => ({
  ...existingTemplate,
  parameteredTexts: themeState.parameteredTexts,
  // Carry over the theme's main image when the existing template already had
  // one, or when the slide's payload declares an image_element placeholder —
  // otherwise applying a theme would inject a main image into slides that
  // were never set up with one and break the project.
  mainImage:
    existingTemplate.mainImage || slideHasImageElement
      ? themeState.mainImage
      : undefined,
  figure: themeState.figure,
  slideLayoutShapes: themeState.slideLayoutShapes,
  slideLayoutType: themeState.slideLayoutType,
  table: themeState.table,
  background: themeState.background,
  logo: {
    ...themeState.logo,
    assetId: existingTemplate.logo.assetId,
    path: existingTemplate.logo.path,
  },
  presenter: {
    ...themeState.presenter,
    presenter: existingTemplate.presenter.presenter,
    contactId: existingTemplate.presenter.contactId,
  },
});
